import { useCallback, useContext, useState } from 'react';
import { UserContext } from '#src/index.jsx';
import useFlights from '#hooks/use-flights.js';

export function useFlightModal({ onClose, startDate, currentDay, addFlight, profileLanguage, itineraryId }) {
    const onCreate = (data) => {
        onClose();
        addFlight(data);
    };

    const { getLanguage } = useContext(UserContext);
    const language = getLanguage() || 'en';

    const [loading, setLoading] = useState(false);

    const { retrieveFlightInfo } = useFlights({
        onCreate,
        cancelLoading: () => setLoading(false)
    });

    let day,
        month,
        year,
        dateStringFormatted = '';

    if (!isNaN(new Date(startDate).getTime())) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate() + currentDay);
        [day, month, year] = startDate.toLocaleDateString('it').split('/');
        dateStringFormatted = startDate.toLocaleDateString(language, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    const [airline, setAirline] = useState(null);
    const [flightNumber, setFlightNumber] = useState(null);

    const isGetInfoDisabled = !airline || !flightNumber;

    const getInfo = useCallback(() => {
        setLoading(true);
        retrieveFlightInfo.mutate({
            airline,
            flightNumber,
            day,
            month,
            year,
            lang: profileLanguage,
            itineraryId
        });
    }, [airline, flightNumber, day, month, year, profileLanguage, itineraryId]);

    return {
        onCreate,
        loading,
        retrieveFlightInfo,
        dateStringFormatted,
        airline,
        setAirline,
        flightNumber,
        setFlightNumber,
        isGetInfoDisabled,
        getInfo
    };
}
